import { style } from 'typestyle'

/* Styles ======================================================================================= */
import { StyleClass } from '../style-class'

/* Types ======================================================================================== */
import { ComponentSizeType } from '../__core/component.types'

/* Types ======================================================================================== */
type ClassNames = {
  component: string
  /**
   * Base class for field
   */
  base: string
  /**
   * Base class for field content section
   */
  fieldBase: string
  /**
   * Proped class for field content section
   */
  fieldProped: {
    focused: string
  }

  fieldSized: {
    xs: string
    small?: string
    sm: string
    md: string
    lg: string
    xl: string
  }

  startBase: string
  endBase: string
}

type ClassProps = {
  size?: ComponentSizeType
}

const getNames: (props: ClassProps, theme: any) => ClassNames = (props, theme) => {
  const component = style({
    width: '100%',
  })

  const base = style({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    $nest: {
      '& input': {
        // border: `1px solid ${theme.boxes.border.medium}`,
        // background: theme.getBaseline('background').color.light,
        // borderRadius: 4,
      },
    },
  })

  const fieldSized = {
    xs: style({ height: 20 }),
    sm: style({ height: 28 }),
    md: style({ height: 32 }),
    lg: style({ height: 36 }),
    xl: style({ height: 44 }),
  }

  const fieldBase = style({
    background: theme.getBaseline('surface').color.light,
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    $nest: {
      '&::after': {
        display: 'none',
      },
    },
  })

  const fieldProped = {
    focused: style({
      background: theme.getBaseline('surface').color.medium,
      boxShadow: `1px 1px 10px 5px ${theme.boxes.shadow.light}`,
      border: 'none',
      $nest: {
        '&::after': {
          display: 'inline-block',
        },
      },
    }),
  }

  const startBase = style({
    background: theme.getBaseline('background').color.light,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
  })

  const endBase = style({
    background: theme.getBaseline('background').color.light,
    display: 'flex',
    alignItems: 'center',
    paddingRight: 8,
  })

  return {
    component,
    base,
    fieldBase,
    fieldProped,
    fieldSized,
    startBase,
    endBase,
  }
}

/* Export ======================================================================================= */
export const fieldClass = new StyleClass<ClassNames, ClassProps>(getNames)
